import { useTheme } from 'styled-components'
import { useMediaQuery } from 'usehooks-ts'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { H2, H3 } from '@/@bothrs-ui/web/components/typography/Heading'
import { breakpoints } from '@/config/layout'

import type { FC } from 'react'

type HomeSectionLayoutProps = {
  title: string
  children: React.ReactNode
}
/**
 * Reusable layout component for the home page
 * This component manages the padding and layout of the children
 *
 * Each section has
 *  - a title
 *  - content (children)
 */
export const HomeSectionLayout: FC<HomeSectionLayoutProps> = ({ title, children }) => {
  const theme = useTheme()
  const isMobileViewport = useMediaQuery(breakpoints.toS)

  return (
    <FlexColumn
      key='activities-and-carepaths'
      gap={isMobileViewport ? theme.UI.Spacing.Space4 : theme.UI.Spacing.Space8}
    >
      {/* TODAY TITLE */}
      {isMobileViewport ? <H3 noMargin>{title}</H3> : <H2 noMargin>{title} </H2>}

      {children}
    </FlexColumn>
  )
}
